module.exports = "<app-poi-edit-general poi=$ctrl.poi on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)></app-poi-edit-general> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/poi/edit/general/template.html
// module id = 437
// module chunks = 0